import { TranslationKeys } from "translations";

export const SettingsNavKeys = {
  General: "general",
  Reference: "reference",
  Address: "address",
  Payment: "payment",
  Other: "other",
  HouseWork: "houseWork",
  InvoiceManagement: "invoiceManagement",
  Reminders: "reminders",
  Display: "display",
};

export const CustomerValuesAutogeneratedKey = TranslationKeys.Common.FetchedFromRegister;
